import React from "react";
import { useEffect, useState } from "react";
import { useAxios } from "../../../hooks/useAxios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Modalibro from "../../../components/modalLibro/ModalLibro";
const rut = "https://www.ricardosalinas.com/images/libros/";

const Libros = () => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation("home");
  const [g] = useTranslation("global");
  const [allBooks, setAllBooks] = useState([]);
  const liga_lang1 = "/" + i18n.language + "/biblioteca";
  const [books, setBooks] = useState(null);
  const [activeTab, setActiveTab] = useState("libros");
  const [items, setItems] = useState([]);
  const [initialLoadFinished, setInitialLoadFinished] = useState(false);

  const liga_lang2 = "/" + i18n.language + "/LibroSociedades";
  const liga_lang3 = "/" + i18n.language + "/LibroLibertad";
  const liga_lang4 = "/" + i18n.language + "/LibroNegocios";
  const liga_lang5 = "/" + i18n.language + "/LibroBitcoin";

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/library/nbooks2?offset=0&next=4&sitioid=2&lenguaje=${i18n.language}`
      );

      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {

    const loadInitialBooks = async () => {

      const data = await fetchData();

      const booksWithoutBanner = data;

      setAllBooks(booksWithoutBanner);

      setInitialLoadFinished(true);
    };


    loadInitialBooks();

  }, [i18n.language]);

  const [im] = useTranslation("libroBitcoin");
  const bannerImageBlanco =
    im("donde.btnaudio") === "ES"
      ? "/assets/img2026/book_cover_4.png"
      : "/assets/img2026/book_cover_4_en.png";
  const bannerImageBitcoin =
    im("donde.btnaudio") === "ES"
      ? "/assets/img2026/book_cover_0.png"
      : "/assets/img2026/bitcoin_englightment.png";

  // Modal
  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");
  const [variable3, setVariable3] = useState("");
  const [variable4, setVariable4] = useState("");
  const [variable5, setVariable5] = useState("");
  const [variable6, setVariable6] = useState("");
  const [variable7, setVariable7] = useState("");
  const [variable8, setVariable8] = useState("");
  const [variable9, setVariable9] = useState("");
  const [variable10, setVariable10] = useState("");

  const openModal2 = (
    value1,
    value2,
    value3,
    value4,
    value5,
    value6,
    value7,
    value8,
    value9,
    idlibro
  ) => {

    setVariable1(value1);
    setVariable2(value2);
    setVariable3(value3);
    setVariable4(value4);
    setVariable5(value5);
    setVariable6(value6);
    setVariable7(value7);
    setVariable8(value8);
    setVariable9(value9);
    setVariable10(idlibro);
    setIsModalOpen2(true);
    //navigate(`/${i18n.language}/recomendados?libro=${idlibro}`);
  };

  const closeModal2 = () => setIsModalOpen2(false);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString(i18n.language, {
      year: "numeric",
    });
  };

  const trackAnalyticsClick = (label) => {
    window.gtag('event', 'click', {
        event_category: 'Home',
        event_label: label,
        value: 1
    });
};

  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };


  return (
    <div class="_nghost-ng-c2125821663">

      <section aria-labelledby="home-books-title" class="home-books">
        <div class="home-books__content home-books__content_ex">
          <header class="home-books__header">
            <div class="home-books__header-left">
              <h2 id="home-books-title">{t("2026.recomendaciones")}</h2><a onClick={() => trackAnalyticsClick('Home - Todas los libros')} class="home-books__desktop-link"
                href={("/" + i18n.language + "/biblioteca")}>{t("2026.recomendaciones-btn")}</a>
            </div>
            <p class="home-books__description">{t("2026.leyenda2")}</p>
          </header>
          <nav aria-label="Categorias de libros" class="home-books__tabs">

            <button
              type="button"
              class={`home-books__tab ${activeTab === "libros"
                ? "home-books__tab--active"
                : ""
                }`}
              onClick={() => setActiveTab("libros")}
            >
              {t("2026.leyenda-btn")}
            </button>

            <button
              type="button"
              class={`home-books__tab ${activeTab === "libros2"
                ? "home-books__tab--active"
                : ""
                }`}
              onClick={() => setActiveTab("libros2")}
            >
              {t("2026.leyenda-btn2")}
            </button>

          </nav>
        </div>
        <div class="home-books__rail">
          <div aria-label="Recomendaciones de libros" class="home-books__grid">

            {activeTab === "libros" ? (
              <>
                <article class="home-books__card"><img loading="lazy" class="home-books__card-image"
                  src={bannerImageBitcoin} alt="La iluminación de bitcoin" />

                  <h3 class="home-books__card-title">{t("2026.libro1")}<br /><p class="home-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                  <p class="home-books__card-author autor-solo-mov">Ricardo Salinas</p>
                  <a class="home-books__card-link" onClick={() => trackAnalyticsClick('Home - Libro RBS: Bitcoin')} 
                    href={liga_lang5}>{t("2026.bookmore")}</a>
                </article>
                <article class="home-books__card"><img loading="lazy" class="home-books__card-image"
                  src="/assets/img2026/book_cover_1.png"
                  alt="Ideas que transforman negocios para cambiar al mundo" />

                  <h3 class="home-books__card-title">{t("2026.libro2")}<br /><p class="home-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                  <p class="home-books__card-author autor-solo-mov">Ricardo Salinas</p>
                  <a class="home-books__card-link" onClick={() => trackAnalyticsClick('Home - Libro RBS: Azul')}
                    href={liga_lang4}>{t("2026.bookmore")}</a>
                </article>
                <article class="home-books__card"><img loading="lazy" class="home-books__card-image"
                  src="/assets/img2026/book_cover_2.png"
                  alt="Ideas que transforman sociedades para cambiar al mundo" />

                  <h3 class="home-books__card-title">{t("2026.libro3")}<br /><p class="home-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                  <p class="home-books__card-author autor-solo-mov">Ricardo Salinas</p>
                  <a class="home-books__card-link" onClick={() => trackAnalyticsClick('Home - Libro RBS: Verde')}
                    href={liga_lang2}>{t("2026.bookmore")}</a>
                </article>
                <article class="home-books__card"><img loading="lazy" class="home-books__card-image"
                  src={bannerImageBlanco}
                  alt="Ideas Sobre la Libertad que cambian el mundo" />

                  <h3 class="home-books__card-title">{t("2026.libro4")}<br /><p class="home-books__card-author autor-solo-desk">Ricardo Salinas</p></h3>
                  <p class="home-books__card-author autor-solo-mov">Ricardo Salinas</p>
                  <a class="home-books__card-link" onClick={() => trackAnalyticsClick('Home - Libro RBS: Blanco')}
                    href={liga_lang3}>{t("2026.bookmore")}</a>
                </article>

              </>
            ) : (
              <>
                {allBooks.map((item, index) => (
                  <>
                    <article class="home-books__card">
                      <img
                        loading="lazy"
                        class="home-books__card-image"
                        src={rut + item.imagen} alt={item.titulo}
                      />

                      <h3 class="home-books__card-title">
                        {item.titulo.split(":")[0]}
                        <br />
                        <p class="home-books__card-author autor-solo-desk">
                          {item.autor}
                        </p>
                      </h3>

                      <p class="home-books__card-author autor-solo-mov">
                        {item.autor}
                      </p>

                      <a
                        href="#"
                        className="home-books__card-link"
                        onClick={(e) => {
                          e.preventDefault();
                          trackAnalyticsClick('Home - Libro recomendado: '+item.titulo);
                          openModal2(
                            rut + item.imagen,
                            item.imagen.substring(0, item.imagen.length - 4),
                            item.titulo,
                            item.descripcion,
                            item.autor,
                            item.editorial,
                            formatDate(item.fecha),
                            item.blog,
                            i18n.language,
                            item.id
                          );
                        }}
                      >
                        {t("2026.bookmore")}
                      </a>
                    </article>
                  </>
                ))}
              </>
            )}

          </div>
        </div>
        <div class="home-books__content"><a class="home-books__mobile-link" onClick={() => trackAnalyticsClick('Home - Todas los libros')}
          href={liga_lang1}>{t("2026.recomendaciones-btn")}</a></div>
      </section>
      <Modalibro
        isOpen={isModalOpen2}
        closeModal={closeModal2}
        variable1={variable1} //ruta con imagen
        variable2={variable2} //titulo
        variable3={variable3} //descripcion
        variable4={variable4} //autor
        variable5={variable5} //editorial
        variable6={variable6} //año
        variable7={variable7} //año
        variable8={variable8} //año
        variable9={variable9} //año
        id_idea={variable10}
      />
    </div>
  );
};

export default Libros;